import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/navigation/Sidebar';
import PatientContextBar from '../../components/navigation/PatientContextBar';
import QuickActions from '../../components/navigation/QuickActions';
import SessionManager from '../../components/navigation/SessionManager';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';


import CareTeamPanel from './components/CareTeamPanel';
import TaskManagementPanel from './components/TaskManagementPanel';
import TreatmentSummaryPanel from './components/ClinicalSummaryPanel';
import MessagingPanel from './components/MessagingPanel';
import TreatmentPlanCoordination from './components/CarePlanCoordination';

const TeamCollaboration = () => {
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeView, setActiveView] = useState('overview');
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const currentPatient = {
    name: "Sarah Elizabeth Johnson",
    mrn: "MRN-2024-789456",
    dob: "03/15/1978",
    age: "47",
    gender: "Female"
  };

  const views = [
    { id: 'overview', label: 'Overview', icon: 'LayoutDashboard' },
    { id: 'tasks', label: 'Tasks', icon: 'CheckSquare' },
    { id: 'summaries', label: 'Treatment Summaries', icon: 'FileText' },
    { id: 'messaging', label: 'Messaging', icon: 'MessageSquare' },
    { id: 'careplans', label: 'Treatment Plans', icon: 'ClipboardList' }
  ];

  return (
    <div className="flex h-screen bg-background pt-16">
      <Sidebar isCollapsed={isSidebarCollapsed} onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <PatientContextBar patient={currentPatient} onAlertClick={() => {}} />
        <QuickActions />
        <SessionManager onSessionExpired={() => {}} onSessionExtended={() => {}} />

        <main className="flex-1 overflow-auto p-4 lg:p-6">
          <div className="max-w-[1600px] mx-auto space-y-6">
            {/* Header */}
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div>
                <h1 className="text-3xl font-bold text-foreground flex items-center gap-3">
                  <Icon name="Users" size={32} className="text-primary" />
                  Team Collaboration
                </h1>
                <p className="text-muted-foreground mt-1">
                  Coordinate multi-disciplinary dental care, assign tasks, and share treatment summaries
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Button variant="outline" iconName="UserPlus">
                  Add Team Member
                </Button>
                <Button variant="default" iconName="Plus">
                  New Task
                </Button>
              </div>
            </div>

            {/* View Tabs */}
            <div className="bg-card rounded-lg border border-border p-1 flex flex-wrap gap-1">
              {views?.map((view) => (
                <button
                  key={view?.id}
                  onClick={() => setActiveView(view?.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    activeView === view?.id
                      ? 'bg-primary text-primary-foreground shadow-sm'
                      : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name={view?.icon} size={16} />
                  <span className="hidden sm:inline">{view?.label}</span>
                </button>
              ))}
            </div>

            {/* Overview View - Three Panel Layout */}
            {activeView === 'overview' && (
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-1">
                  <CareTeamPanel />
                </div>
                <div className="lg:col-span-2 space-y-6">
                  <TaskManagementPanel compact={true} />
                  <MessagingPanel compact={true} />
                </div>
              </div>
            )}

            {/* Tasks View */}
            {activeView === 'tasks' && (
              <TaskManagementPanel compact={false} />
            )}

            {/* Treatment Summaries View */}
            {activeView === 'summaries' && (
              <TreatmentSummaryPanel />
            )}

            {/* Messaging View */}
            {activeView === 'messaging' && (
              <MessagingPanel compact={false} />
            )}

            {/* Treatment Plans View */}
            {activeView === 'careplans' && (
              <TreatmentPlanCoordination />
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default TeamCollaboration;